// Отступы, радиусы, тени. Источник: design/README.md.
//
// Файл разделён на три части, и смешивать их нельзя. Общее — то, что следует
// из формы, а не из устройства: шаг отступов, радиусы, тени. Дальше MOBILE и
// WEB. Отступ 68px сверху — это место под статус-бар айфона, в браузере его
// нет; левая колонка 264px — это десктоп, на телефоне её не существует.
// Пока писали только под iOS, различать было нечего, и оба набора лежали
// вперемешку; с выходом веба первым (docs/stack.md) это перестало годиться.

/** Шаг вертикальных отступов — из дизайна, произвольных значений не вводить. */
export const SPACING = [8, 10, 12, 14, 18, 22, 34] as const

export const RADII = {
  card: 20,
  cardNested: 14,
  button: 16,
  pill: 999,
  input: 26,
  /** Нижний шит на мобильном: скругляются только верхние углы. */
  sheet: 30,
  /** Окно подтверждения на десктопе — то же содержимое, другая раскладка. */
  modal: 24,
  /** Строка левой колонки в вебе. */
  navRow: 10,
} as const

/** Пузыри чата: разные скругления у пользователя и ассистента. */
export const BUBBLE_RADII = {
  user: [20, 20, 6, 20],
  assistant: [20, 20, 20, 6],
} as const

/**
 * Тени. Цвет задан именем токена и прозрачностью, а не готовым значением:
 * платформы записывают тень по-разному, и общим здесь может быть только
 * состав. Отрицательный `y` у шита — тень вверх, он приходит снизу.
 */
export const SHADOWS = {
  card: { x: 0, y: 4, blur: 14, color: 'ink', alpha: 0.07 },
  sheet: { x: 0, y: -12, blur: 40, color: 'ink', alpha: 0.18 },
  /** Карточка задачи под курсором и выбранная карточка. */
  cardActive: { x: 0, y: 6, blur: 18, color: 'accent', alpha: 0.1 },
} as const

/** Кольцо вокруг поля в фокусе — сплошное, без размытия. Одинаково везде. */
export const FOCUS_RING = { width: 4, color: 'accent', alpha: 0.14 } as const

/**
 * Движение: длительности и кривая. Опора — `design/README.md`: «дизайн не
 * содержит нестандартных анимаций, достаточно системных переходов», а
 * единственное названное там число — 200 мс с ease-out у строк источников.
 * Отсюда и всё остальное; произвольных значений в разметке не заводить.
 *
 * Общими они лежат по той же причине, что радиусы: это следует из ощущения, а
 * не из устройства. Окно, которое на телефоне приезжает за 240 мс, а в
 * браузере за 400, — это два разных продукта, а не один на двух платформах.
 *
 * ⚠️ УХОД КОРОЧЕ ПРИХОДА, и это не экономия. Приход показывают: на него
 * смотрят, и он обязан успеть объяснить, откуда взялось окно. Уход только
 * убирают — то, что человек уже решил закрыть, он разглядывать не будет, и
 * каждый лишний кадр здесь читается задержкой интерфейса, а не плавностью.
 *
 * Кривая одна на всё и НЕСИММЕТРИЧНАЯ. Симметричная `ease-in-out` половину
 * времени держит окно почти неподвижным — ровно то ощущение заторможенности,
 * ради которого этот набор и заведён.
 */
export const MOTION = {
  /** Панель шита и модального окна: сдвиг и появление. */
  sheet: { in: 240, out: 170 },
  /**
   * Затемнение под ними. СВОИМ временем и БЕЗ сдвига — затемнение не
   * приезжает, оно проявляется. Общая анимация на панель и фон выдаёт
   * полупрозрачный прямоугольник, который ползёт вверх вместе с окном.
   */
  scrim: { in: 180, out: 140 },
  /** Меню, подсказки, всплывающие карточки: короче, они меньше и ближе. */
  pop: 120,
  /** Появление строк по стриму — единственное число прямо из дизайна. */
  stream: 200,
  /** Кривая выхода в нотации `cubic-bezier`: резкий старт, мягкое доезжание. */
  ease: [0.22, 1, 0.36, 1],
} as const

/**
 * Закрытие шита свайпом вниз.
 *
 * Два условия через ИЛИ, а не одно: медленное длинное движение и быстрый
 * короткий рывок одинаково означают «убери», и порог только по расстоянию
 * ловит первое, отвергая второе. Доля высоты панели, а не пиксели: короткое
 * окно должно закрываться коротким движением.
 */
export const SWIPE_TO_DISMISS = { distance: 0.28, velocity: 0.5 } as const

/**
 * Потолок высоты поля вопроса — одно число на оба клиента. SMY-360
 *
 * Поле растёт под текст, но не бесконечно: с четырёх строк лента уходит под
 * клавиатуру на телефоне и под поле в кабинете, а написанное всё ещё надо
 * видеть — дальше поле прокручивается. До 05.10.2026 число жило в одном
 * приложении: поле кабинета было однострочным, и длинный вопрос был виден
 * только хвостом.
 */
export const COMPOSER_MAX_HEIGHT = 120

/** Экраны 01–11 в рамке 402×874. iOS сейчас, Android следом — P9. */
export const MOBILE = {
  /** Горизонтальные поля экрана. На экране входа — 26. */
  padding: { screen: 20, entry: 26 },
  /** Сверху под статус-бар, снизу под home indicator. */
  insets: { top: 68, topEntry: 74, bottom: 46 },
  /**
   * Минимальная зона нажатия. 44 — требование доступности, соблюдено для
   * чипов, текстовых ссылок и строк списков.
   */
  hit: 44,
  button: { primary: 52, secondary: 44 },
  /** Тогл iOS. На Android заменяется системным компонентом. */
  toggle: { width: 51, height: 31, knob: 25 },
} as const

/** Кабинет 1440×900 и его адаптив. Первая выпускаемая платформа. */
export const WEB = {
  /**
   * Две колонки: навигация и лента.
   *
   * Третья — источники и состав результата — убрана 06.09.2026 вместе с
   * правой колонкой оболочки. Держать её ширину «на всякий случай» значило бы
   * оставить в токенах размер того, чего нет: вернётся колонка — вернётся и
   * число, а пока оно только вводит в заблуждение.
   */
  columns: { nav: 264 },
  /** Шапка с локапом и плашками остатков; заголовок ленты под ней. */
  header: 60,
  feedHeader: 54,
  /** Поля центральной колонки и отступ поля ввода от низа. */
  content: { x: 44, y: 28, composerBottom: 26 },
  /** Строка левой колонки: иконка, подпись, активное состояние. */
  navRow: { minHeight: 38, paddingY: 9, paddingX: 10, icon: 18 },
  /** Окно подтверждения по центру, поверх затемнения `scrim`. */
  modal: 560,
  /** Правая колонка входа. Ширина та же, что у окна, — совпадение, не связь. */
  signInForm: 560,
  /**
   * Под курсором строка может быть ниже 44px: мышь попадает туда, куда палец
   * не попадает. На кнопках и ниже контрольной точки 44 возвращается —
   * иначе в адаптиве получится интерфейс, в который нельзя ткнуть.
   */
  hit: { row: 38, rowMin: 36, button: 44 },
  toggle: { width: 46, height: 28, knob: 24 },
  /** Сетка карточек задач на пустом экране. */
  taskGrid: { desktop: 3, compact: 2 },
  /** Ниже этой ширины кабинет перестраивается по мобильным правилам. */
  breakpoint: 900,
  /** Шапка в адаптиве: левая колонка уходит в выдвижное меню. */
  headerCompact: 54,
  /**
   * Миллисекунды. Наведение и появление строк источников по стриму.
   *
   * Оба числа берутся из `MOTION`, а не пишутся здесь своими: одинаковые
   * значения в двух местах остаются одинаковыми ровно до первой правки.
   */
  transition: { hover: MOTION.pop, sources: MOTION.stream },
} as const
